import { useTranslation } from 'react-i18next';

export const TERMS_URL = 'https://ardealy.com/terms';
export const PRIVACY_URL = 'https://ardealy.com/privacy';

/**
 * "By continuing you agree to the Terms and the Privacy policy", under both
 * ways in (Google creates the account in one click, so it sits below the
 * form, not beside one button). The sentence is translated whole and the two
 * links are cut out of it, so each language keeps its own word order.
 */
export const LegalNote = () => {
    const { t } = useTranslation();
    const T = '[[terms]]';
    const P = '[[privacy]]';
    const sentence = String(t('SIGNUP.ACCOUNT.LEGAL', { terms: T, privacy: P }));
    const link = (href: string, label: string) => (
        <a key={href} href={href} target="_blank" rel="noopener noreferrer" className="text-foreground underline-offset-2 hover:underline">
            {label}
        </a>
    );
    return (
        <p className="mt-6 text-center text-xs leading-relaxed text-muted-foreground" data-testid="signup-legal">
            {sentence.split(/(\[\[terms\]\]|\[\[privacy\]\])/).map((part, i) =>
                part === T ? link(TERMS_URL, t('SIGNUP.ACCOUNT.LEGAL_TERMS')) : part === P ? link(PRIVACY_URL, t('SIGNUP.ACCOUNT.LEGAL_PRIVACY')) : <span key={i}>{part}</span>,
            )}
        </p>
    );
};
